import React from "react";

function RowComponentStatus({ label, value }) {
    return (
        <>
            <div class="row-status">
                <div
                    className="box-for-text-content"
                    style={{ paddingRight: "9px" }}
                >
                    <span className="text-content">{label}</span>
                </div>
                <div class="box" style={{ paddingLeft: "9px" }}>
                    <span class="text-for-tag">{value}</span>
                </div>
            </div>
        </>
    );
}

export default RowComponentStatus;
